import React from 'react';
import { CircularLoader } from '../../../../components';
import { makeStyles } from '@material-ui/core/styles';

export const WidgetLoader = ({ loading }) => {
  const classes = useStyles();

  return (
    <CircularLoader
      isLoading={!!loading}
      loaderClassName={classes.loaderClassName}
      className={classes.loaderWrapper}
    />
  );
}

const useStyles = makeStyles({
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  loaderWrapper: {
    position: 'fixed'
  },
  tabPanel: {
    height: '100%'
  }
});

export default WidgetLoader;
